import { PurpleTooltip } from "designSystem/Tooltips";
import React from "react";
import { createUseStyles } from "react-jss";
import { CDN_URL } from "Constants/CDN";
import LazyImage from "ComponentsUI/Image";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
	},
	rootAntiFilter: {
		display: "flex",
		flexDirection: "column",
	},
	header: {
		marginBottom: "5px",
		fontSize: "12px",
		fontFamily: `${theme.fonts.medium}`,
		color: `${theme.palette.colors.darkSlateBlue}`,
	},
	headerAtnifilter: {
		marginBottom: "5px",
		fontSize: "12px",
		fontFamily: `${theme.fonts.medium}`,
		color: `${theme.palette.colors.darkSlateBlue}`,
	},
	imageElements: {
		display: "flex",
		justifyContent: "center",
		flexWrap: "wrap",
		width: "100%",
		gap: "8px",
	},
	imageElementsAntifilter: {
		display: "flex",
		justifyContent: "center",
		flexWrap: "wrap",
		width: "100%",
		gap: "8px",
	},
	svgImage: {
		borderTopLeftRadius: "0px",
	},
	img: {
		height: "25px",
		maxWidth: "100%",
		cursor: "pointer",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		imageElements: {
			gap: "6px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			flexDirection: "row",
			alignItems: "flex-start",
		},
		rootAntiFilter: {
			display: "flex",
			flexDirection: "column",
		},
		header: {
			marginRight: "10px",
			position: "relative",
			top: "12px",
		},
		headerAtnifilter: {
			marginRight: "10px",
			top: "12px",
		},
		imageElementsAntifilter: {
			display: "grid",
			gridTemplateColumns: "repeat(auto-fit, 25px)",
			justifyContent: "center",
			columnGap: "20px",
		},
		imageElements: {
			display: "grid",
			gridTemplateColumns: "repeat(auto-fit, 25px)",
			justifyContent: "end",
			columnGap: "20px",
		},
		img: {
			margin: "4px 0px",
		},
	},
}));

export const UnlimitedSocial = ({ header, socialData, antifilter }) => {
	const classes = useStyles();

	return (
		<div className={antifilter ? classes.rootAntiFilter : classes.root}>
			<span className={antifilter ? classes.headerAtnifilter : classes.header}>{header}</span>
			<div className={antifilter ? classes.imageElementsAntifilter : classes.imageElements}>
				{socialData.map(({ key, tooltipText }, index) => {
					return (
						<PurpleTooltip key={index} content={tooltipText}>
							<LazyImage
								src={`${CDN_URL}/images/social/${key}.svg`}
								className={classes.img}
								alt={key}
							/>
						</PurpleTooltip>
					);
				})}
			</div>
		</div>
	);
};
